@import '@hevoio/hevo-ui-toolkit/styles/variables';

.workbenchSchemaExplorerWrapper {
  flex-shrink: 0;
  width: 300px;
  position: sticky;
  top: $spacer * 1.25;
}

.queryViewContainer {
  min-width: 0;
  flex: 1;
  padding-left: $spacer * 1.25;
}

.queryRunOutputLoading {
  padding-top: $spacer * 5;
  padding-bottom: $spacer * 5;
}
